
const digest = '703c613851cf01f1a53a5421744ab5c9390776e4532d30bba1f3ce8cf66145e1';
const classes = {"wrapper":"_wrapper_axwsq_1","list":"_list_axwsq_9"};
const css = `._wrapper_axwsq_1 {
  font-family: "Rubik", sans-serif;
  display: flex;
  flex-direction: column;
  border: 1px solid #eaedf3;
  height: 100%;
  position: relative;
}
._wrapper_axwsq_1 ._list_axwsq_9 {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  overflow-y: scroll;
  box-shadow: inset 0 4px 0 0 rgba(226, 229, 237, 0.3);
  -ms-overflow-style: auto;
  scrollbar-width: 3px;
}
._wrapper_axwsq_1 ._list_axwsq_9::-webkit-scrollbar {
  display: block;
}
._wrapper_axwsq_1 ._list_axwsq_9::-webkit-scrollbar {
  width: 4px;
  height: 4px;
  padding: 2px;
}
._wrapper_axwsq_1 ._list_axwsq_9::-webkit-scrollbar-track {
  background: #f1f1f1;
}
._wrapper_axwsq_1 ._list_axwsq_9::-webkit-scrollbar-thumb {
  background: #3e3f42;
  border-radius: 4px;
}
._wrapper_axwsq_1 ._list_axwsq_9::-webkit-scrollbar-thumb:hover {
  background: #3e3f42;
  border-radius: 4px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  